import { render } from "./inventariobarra.vue?vue&type=template&id=1e9fd08b&scoped=true"
import script from "./inventariobarra.vue?vue&type=script&lang=js"
export * from "./inventariobarra.vue?vue&type=script&lang=js"

import "./inventariobarra.vue?vue&type=style&index=0&id=1e9fd08b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9fd08b"]])

export default __exports__